<template>
  <div class="page-infomaion" :class="{'mobile': _isMobile}">
    <div class="infomaion-wrap" :class="{'pc': !_isMobile}">
      <cmpBanner bannerType="11"></cmpBanner>

      <div class="g-wrap">
        <!-- <cmpTab :tabs="tabList" :activeVal="activeVal" :subHeight="'760px'" @eventTabClick="eventTabClick"></cmpTab> -->

        <!-- 博物馆章程 -->
        <div class="con" v-if="activeVal==='2'">
          <cmpDetail :detailData="data2"></cmpDetail>
        </div>

        <!-- 新闻动态 -->
        <div class="con con-dynamic g-info-list" v-if="activeVal==='3'">
          <div class="list g-list-pad-top">
            <div class="item" v-for="(item, i) in dataList" :key="i" @click="goDetail(item)">
              <div class="pic-box mb-20" v-if="i==0&&item.picture">
                <img v-lazy="item.picture" alt="">
              </div>
              <div class="name m-font-5">
                <i></i>
                <span>【{{item.subCategory}}】</span>
                <h1 class="ell">{{item.name}}</h1>
              </div>
              <p class="time m-font-7">{{item.publishTime}} · {{item.author}}</p>
              <p class="desc two-ell m-font-6">{{item.text}}</p>
            </div>
          </div>

          <!-- 无数据 -->
          <div class="g-no-data" v-if="dataList.length === 0 && !listLoading">
            <div class="no-data-bg"></div>
            <p class="txt text-center">暂无数据</p>
          </div>

          <cmpMyPagination :currentPage="listQuery.page" :pageSize="listQuery.size" :total="total" @eventPage="eventPage"></cmpMyPagination>
        </div>
        
        <!-- 机构设置 -->
        <div class="con con-organiz" v-if="activeVal==='4'">
          <div class="top">
            <h1 class="m-font-3">博物馆下设6个部门，具体机构设置如下所示：</h1>
            <img src="~@images/image_jigou.png" alt="">
          </div>

          <div class="bottom" v-if="data4.content">
            <cmpDetail :detailData="data4"></cmpDetail>
          </div>

          <!-- 静态文案 勿删 -->
          <div class="bottom" v-else>
            <!-- <div class="item" v-for="i in 6">
              <h2 class="mb-10">
                <label class="m-font-3">展览策划部</label>
                <i> / </i>
                <span>Exhibition Planning Department</span>
              </h2>
              <div class="des m-font-5">
                <p>1、负责自办展项目的组织实施。从策划到项目的实施，全权负责。</p>
                <p> 2、定期向领导汇报招展进度和计划措施。</p>
                <p> 3、负责协助部门经理参与项目评审，并提出合理化建议。</p>
                <p> 4、负责协助项目经理对项目进行各类宣传工作的文案编写。</p>
                <p> 5、负责协助各项目做好其他各类策划工作。</p></p>
              </div>
            </div> -->
          </div>
        </div>

        <!-- 联系我们 -->
        <div class="con con-contact" v-if="activeVal==='5'">
          <div class="card-list m-font-3">
            <div class="item">
              <img class="icon mr-20" src="~@images/icon_dianhua.png" alt="">
              <div class="txt">
                <p class="name mb-10">联系电话</p>
                <p class="m-font-5"><a :href="'tel:0377-63512907'" style="color:inherit;">0377-63512907</a></p>
              </div>
            </div>
            <div class="item">
              <img class="icon mr-20" src="~@images/icon_youxiang.png" alt="">
              <div class="txt">
                <p class="name mb-10">邮箱</p>
                <p class="m-font-5">nywhc2023@163.com</p>
              </div>
            </div>
            <div class="item">
              <img class="icon mr-20" src="~@images/icon_jubao.png" alt="">
              <div class="txt">
                <p class="name mb-10">举报投诉</p>
                <p class="m-font-5"><a :href="'tel:0377-63512907'" style="color:inherit;">0377-63512907</a></p>
              </div>
            </div>
          </div>

          <div class="map">
            <img src="~@images/map_2.png" alt="" v-if="!_isMobile">
            <img src="~@images/map_h5.png" alt="" v-if="_isMobile">

            <!-- <div id="map" class="map"></div> -->
          </div>

          <div class="code-box m-font-3">
            <div class="item">
              <p>
                <img class="icon" src="~@images/icon_wechat.png" alt="">
                微信公众号
              </p>
              <img class="pic_code mt-20" :src="$store.state.app.globalInfo.museumInfo.qrcodeXcx" alt="">
            </div>

            <div class="item">
              <p>
                <img class="icon" src="~@images/icon_xiaochengxu.png" alt="">
                微信小程序
              </p>
              <img class="pic_code mt-20" :src="$store.state.app.globalInfo.museumInfo.qrcodeWx" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@assets/css-mobile/information/index.scss'
export default {
  watch: {
    $route() {
      this.activeVal = this.$route.query.pageType || '1'
      this.activeSubVal = this.$route.query.subType || '2'

      this.getData()
    }
  },
  data() {
    return {
      activeVal: this.$route.query.pageType || '3',
      tabList: [
        {
          name: '关于我们',
          val: '1'
        },
        {
          name: '博物馆章程',
          val: '2'
        },
        {
          name: '新闻动态',
          val: '3'
        },
        {
          name: '机构设置',
          val: '4'
        },
        // {
        //   name: '联系我们',
        //   val: '5'
        // }
      ],
      activeSubVal: this.$route.query.subType || '',
      // activeSubVal: '',
      subTabList: [
        // {
        //   name: '诸葛亮躬耕地',
        //   val: '1'
        // },
        // {
        //   name: '武侯祠历史门票',
        //   val: '2'
        // },
        // {
        //   name: '诸葛亮论坛',
        //   val: '3'
        // }
      ],
      
      detailData: {},
      dataList: [],
      listQuery: {
        page: 1,
        size: 10
      },
      total: '0',
      listLoading: false,
      data1: [],
      data2: {},
      // data3: {},
      data4: {},
      data5: {}
    }
  },
  methods: {
    getData() {
      switch(this.activeVal) {
        case '1':
          this.getData1()
          break
        case '2':
          this.getData2()
          break
        case '3':
          this.listQuery.page = 1
          this.getData3()
          break
        case '4':
          this.listQuery.page = 1
          this.getData4()
          break
        case '5':
          this.listQuery.page = 1
          this.getData5()
          break
      }
    },
    showMap(){
      var map = new BMap.Map("map");
      var point = new BMap.Point(this.latitude,this.longitude);
      var marker = new BMap.Marker(point);
      map.addOverlay(marker);
      map.centerAndZoom(point, 14);
      map.enableScrollWheelZoom();
    },
    // 关于我们
    getData1() {
      this.$http
        .get('/webapi/information/about', {})
        .then(res => {
          if (res.success) {
            let data = res.data
            data.forEach(item => {
              item.val = item.id
            })
            this.data1 = res.data
            this.subTabList = this.data1

            if(this.$route.query.subType) {
              this.detailData = this.subTabList.find(item => item.id == this.$route.query.subType)
            } else {
              this.detailData = this.data1[0]
            }
            this.activeSubVal = this.detailData.id
          } else {
            this.$message.error(res.message)
          }
        })
    },
    // 博物馆章程
    getData2() {
      this.$http
        .get('/webapi/information/rules', {})
        .then(res => {
          if (res.success) {
            this.data2 = res.data
          } else {
            this.$message.error(res.message)
          }
        })
    },
    // 新闻动态
    getData3(val) {
      this.listLoading = true
      this.$http
        .get('/webapi/information/notify', {
          ...this.listQuery
        })
        .then(res => {
          this.listLoading = false
          if (res.success) {
            let data = res.data
            this.dataList = data.records
            this.total = data.total
          } else {
            this.$message.error(res.message)
          }
        }).catch(err => {
        })
    },
    // 机构设置
    getData4() {
      this.$http
        .get('/webapi/information/structural', {})
        .then(res => {
          if (res.success) {
            this.data4 = res.data
          } else {
            this.$message.error(res.message)
          }
        })
    },
    getData5() {},
    eventTabClick(val) {
      this.activeVal = val
      this.listQuery.page = 1
      this.getData()
    },
    eventSubTabClick(val) {
      this.activeSubVal = val
      this.detailData = this.subTabList.find(item => item.val == val)
    },
    goDetail(item) {
      this.$router.push({
        path: '/notice/detail',
        query: {
          id: item.id,
          pageType: this.activeVal
        }
      })
    },
    eventPage(obj) {
      this.listQuery.page = obj.page
      this.listQuery.size = obj.size
      this.getData3()
    },
  },
  created() {
    this.getData()
  }
}
</script>

<style lang="scss" scoped>
.infomaion-wrap {
  .con {
    padding-bottom: 30px;
    // padding: 30px 0;
    // width: 1000px;
    margin: 0 auto;
    box-sizing: border-box;
  }
  #map {
    width: 300px;
    height: 300px;
  }

  .con-organiz {
    .top {
      width: 584px;
      margin: 0 auto;
      text-align: center;
      h1 {
        font-weight: bold;
        margin-bottom: 40px;
      }
      img {
        width: 100%; 
      }
    }
    .bottom {
      margin-top: 30px;
      line-height: 28px;
      .item {
        margin-bottom: 30px;
      }
      h2 {
        font-size: 14px;
        color: rgba($color: #3D3D3D, $alpha: 0.5);
        label {
          font-weight: bold;
          color: rgba($color: #3D3D3D, $alpha: 1);
        }
      }
    }
  }

  .con-contact {
    .card-list {
      display: flex;
      .item {
        display: flex;
        align-items: center;
        padding-left: 50px;
        box-sizing: border-box;
        width: calc((100% - 40px)/3);
        height: 82px;
        background: url(~@images/lianxiwomen_card.png);
        background-size: 100% 100%;
        margin-right: 20px;
        &:nth-child(3n) {
          margin-right: 0;
        }

        .icon {
          width: 36px;
        }
      }
    }
    .map {
      margin: 20px 0;
      img {
        width: 100%;
      }
    }
    .code-box {
      display: flex;
      .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        width: calc((100% - 20px)/2);
        height: 260px;
        background: url(~@images/lianxiwomen_card_weixin.png);
        background-size: 100% 100%;
        margin-right: 20px;
        &:nth-child(2n) {
          margin-right: 0;
        }
        p {
          display: flex;
          align-items: center;
          .icon {
            width: 33px;
            margin-right: 10px;
          }
        }
        .pic_code {
          width: 120px;
        }
      }
    }
  }

  .con-dynamic {
    // .list {
    //   margin-bottom: 30px;
    //   .item {
    //     padding: 24px 0;
    //     border-bottom: 1px dashed #8894A8;
    //     &:last-child {
    //       border-bottom: none;
    //     }
    //     .pic-box {
    //       text-align: center;
    //       img {
    //         max-width: 100%;
    //         max-height: 560px;
    //       }
    //     }
    //     .name {
    //       display: flex;
    //       align-items: center;
    //       font-weight: bold;
    //       i {
    //         width: 15px;
    //         height: 30px;
    //         background: url(~@images/image_list.png);
    //         background-size: 100% 100%;
    //       }
    //       h1 {
    //         flex: 1;
    //         font-weight: bold;
    //       }
    //     }
    //     .time {
    //       margin: 15px 0 30px;
    //       color: #4E5D78;
    //     }
    //   }
    // }
  }


  .sub-tab-con {
    width: 100%;
    display: flex;
    justify-content: space-between;
    .sub-tab {
      .sub-item {
        width: 238px;
        height: 42px;
        margin-bottom: 25px;
        font-size: 16px;
        color: $primary;
        display: flex;
        justify-content: center;
        align-items: center;
        background: url(~@images/sub-tab-bg.png) no-repeat center center;
        background-size: 100% 100%;
        cursor: pointer;
        &.active {
          background: url(~@images/sub-tab-bg-active.png) no-repeat center center;
          background-size: 100% 100%;
          color: #fff;
        }
      }
    }

    .sub-con-right {
      margin-left: 40px;
    }

    .g-detail-html {
      margin: 0;
    }
  }
}
</style>


